import { Injectable, inject } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, finalize, tap } from 'rxjs/operators';
import { LoggerProvider } from '@shared';
import { CaseFormRepository } from '../../../infrastructure/repositories/case-form.repository';
import { CaseFormState } from '../../states/case-form.state';
import { DiscardDraftQuery } from './discard-draft.query';

/**
 * Discard Draft Use Case
 * Discards the draft version of a case form
 */
@Injectable({ providedIn: 'root' })
export class DiscardDraftUseCase {
  private readonly _repository = inject(CaseFormRepository);
  private readonly _state = inject(CaseFormState);
  private readonly _logger = inject(LoggerProvider).createScoped('DiscardDraftUseCase');

  public execute(query: DiscardDraftQuery): Observable<void> {
    this._state.setLoadingCaseForm(true);
    this._state.clearErrorCaseForms();

    return this._repository.discardDraft(query.formId).pipe(
      tap(() => this._logger.info('Discarded draft', { formId: query.formId })),
      catchError((error) => {
        const errorMessage =
          error?.error?.message ||
          error?.message ||
          `Failed to discard draft for form ${query.formId}`;
        this._state.setErrorCaseForms(errorMessage);
        return throwError(() => error);
      }),
      finalize(() => this._state.setLoadingCaseForm(false))
    );
  }
}
